<template>
  <div :class="['videoInterview__questions']">
    <div class="videoInterview__container">
      <div class="recorder-section">
        <template v-if="isBadBrowser && show_recorder">
          <bad-browser :locale="locale" />
        </template>

        <template v-else>
          <vrecorder
            :src="tempBlob || video_player_src"
            :duration="duration"
            :action="recorderAction"
            :upload-progress="uploadProgress"
            :show_recorder="show_recorder"
            :show_player="is_show_player && !is_retake"
            :has_mask_on_video="false"
            :hide_safari="false"
            :is_retake_video="isRerecordAllowed && !recording"
            bg_blue
            @startRecording="startRecording"
            @stopRecording="stopRecording"
            @completeRecording="completeRecording"
            @retakeTestVideo="retakeTestVideo"
          />

          <div
            v-if="(video_player_src || tempBlob) && !recording && stage !== 'recording'"
            class="videointerview-buttons-group"
          >
            <vbutton
              class="videointerview-button"
              label="videoInterview.checkVideo.retakeTest"
              color="grey"
              bg_color="white"
              @click="retakeTestVideo(true)"
            />

            <vbutton
              class="videointerview-button"
              label="actions.save"
              :loading="loading"
              :disabled="disable_save_video"
              @click="saveVideointerview"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import IEBrowserDetector from '@/components/mixin/IEBrowserDetector.js';
import SafariBrowserDetector from '@/components/mixin/SafariBrowserDetector.js';
import BadBrowser from '@/components/interview/BadBrowser';

export default {
  name: 'VacancyVideointerview',

  components: {
    BadBrowser
  },

  mixins: [IEBrowserDetector, SafariBrowserDetector],

  props: ['id', 'video_player_src', 'is_retake', 'disable_save_video'],

  data() {
    return {
      recorderAction: 'ready',
      retake: this.isVideoRecorded ? this.isVideoRecorded : false,
      switchToPlayer: false,
      stage: 'start',
      duration: 180,
      isRerecordAllowed: true,
      tempBlob: null
    };
  },

  computed: {
    ...mapState('interview/videointerview', ['loading', 'error', 'recording', 'uploadProgress']),

    ...mapState('locale', { locale: 'value' }),

    // locale() {
    //   return this.$store.getters['locale/current'];
    // },

    is_show_player() {
      return !!(this.video_player_src || this.tempBlob);
    },

    show_recorder() {
      return (!this.switchToPlayer && !(this.video_player_src || this.tempBlob)) || this.is_retake;
    },

    isVideoRecorded() {
      return this.video_player_src || this.tempBlob;
    },

    // is_skip_disable() {
    //   return this.stage === 'recording' || this.uploadProgress;
    // },

    // tooltip_content() {
    //   return this.$tr('videoInterview.skipVideo.helper');
    // },

    // show_video_recorder() {
    //   return !this.switchToPlayer;
    // },

    isBadBrowser() {
      return this.isEdge || this.isIE11OrOlder || this.defineRecordingFlow === 'notallowed';
    }
  },

  watch: {
    isVideoRecorded(val) {
      this.retake = !!val;
    }
  },

  beforeDestroy() {
    this.$store.commit('services/clear');
  },

  methods: {
    ...mapMutations('interview/videointerview', ['setUploadProgress']),

    retakeTestVideo() {
      this.switchToPlayer = false;
      this.setUploadProgress(0);
      this.$emit('retakeTestVideo');
    },

    startRecording() {
      if (this.recorderAction !== 'ready') {
        throw Error('Record not ready');
      }
      this.$emit('startRecording');
      this.recorderAction = 'start';
      this.stage = 'recording';
    },

    stopRecording() {
      if (this.recorderAction !== 'start') {
        throw Error('Record not started');
      }

      this.recorderAction = 'stop';
      this.stage = '';

      setTimeout(() => {
        this.recorderAction = 'ready';
      }, 800);
    },

    completeRecording({ blob }) {
      this.recorderAction = 'ready';
      this.setUploadProgress(100);
      this.stage = '';
      this.tempBlob = URL.createObjectURL(blob);
      this.$emit('complete_recording', { blob, tempBlob: this.tempBlob });
      // this.video_player_src = URL.createObjectURL(blob);
      this.recorderAction = 'ready';
    },

    saveVideointerview() {
      this.stage = '';
      this.$emit('save');
    }

    // noCache(str) {
    //   return str + '?' + Math.random();
    // },

    // canGo() {
    //   return window.confirm(this.$tr('interview.videointerview.update_page'));
    // },

    // player_play() {
    //   if (this.isVideoRecorded) {
    //     return;
    //   }
    // },
    //
    // player_pause() {
    //   if (this.isVideoRecorded) {
    //     return;
    //   }
    // }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .video__container {
    display: flex !important;
    justify-content: center;

    video {
      max-width: 500px !important;
    }
  }
}

.vid-int-videoTest__new-video {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $green;
  color: #fff;
  font-size: 18px;
  user-select: none;
  cursor: default;
}

.vid-int-videoInterview__button {
  margin-top: 20px;
  user-select: none;
}

.videoInterview__question__tale {
  position: absolute;
  bottom: 10px;
  left: -30px;
}

.videoInterview__question {
  position: relative;
  background-color: #fff;
  border: 1px solid #fff;
  border-radius: 18px;
  padding: 30px;
  float: left;
  margin: 24px 0 0;
  box-shadow: 7px 10px 30px -22px #000;
  min-height: 80px;
  max-width: 300px;
  min-width: 300px;
  box-sizing: border-box;
  white-space: pre-wrap;
}

.videoInterview__questions-container {
  position: relative;
  width: 300px;
  margin-right: 30px;
  margin-bottom: 80px;
}

.videoInterview__container {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

.videoInterview__questions {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  font-size: 17px;
  min-height: 375px;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 30px;
}

.videoInterview__questionCounter {
  font-size: 15px;

  .not-mandatory {
    font-size: 0.75em;
  }
}

.not-mandatory {
  font-size: 15px;
  line-height: 22px;
  color: #9faab6;
}

.skip-block {
  cursor: pointer;
  font-size: 15px;

  &:before {
    content: '';
    display: table;
    clear: both;
  }

  .vcv-button {
    margin-top: 10px;
  }

  .button_custom {
    position: relative;
    background: #f4f5f7;
    border-radius: 2px;
    border: 1px solid $green;
    color: $green;
    text-transform: none;
    font-weight: 500;
    font-size: 15px;

    &:hover {
      background: #e3e6ed;
    }

    &:focus {
      background: #f4f5f7;
      border: 1px solid #437aee;
      box-sizing: border-box;
    }

    &:disabled {
      opacity: 0.8;
      pointer-events: none;
      cursor: default;
    }

    .skip-block__tooltip {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
  }
}

.videoInterview__questionCounter_weight {
  font-weight: 600;
}

.footer-section-wrapper {
  position: relative;
  width: 100%;
}

.next-question {
  position: absolute;
  display: flex;
  top: -120px;
  left: 16px;
}

.recorder-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.videoInterview__questions__video {
  background-color: #fff;
  max-width: 1200px;

  .videoInterview__questions-container,
  .vid-int-videoTest__video-container {
    width: 564px;
  }

  .videoInterview__container {
    padding: 24px 16px 60px 16px;
  }

  .skip-block {
    .button_custom {
      border: none;
    }
  }
}

.questions-actions {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -80px;
}

.videointerview-buttons-group {
  display: flex;
  align-items: center;
  margin-top: 20px;

  .videointerview-button {
    &:not(:last-child) {
      margin-right: 20px;
    }
  }
}
</style>
